<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                countryForm: () => import('../forms/CountryForm'),
                fields: [
                    { type: 'text', text: 'Street', value: 'street', rules: [v => !!v || 'Street is required', v => !(v && v.length > 450) || 'Street must be less than 450 characters'], isRequired: true, maxLength: 450 },
                    { type: 'text', text: 'City', value: 'city', rules: [v => !!v || 'City is required', v => !(v && v.length > 100) || 'City must be less than 100 characters'], isRequired: true, maxLength: 100 },
                    { type: 'text', text: 'State', value: 'state', rules: [v => !!v || 'State is required', v => !(v && v.length > 100) || 'State must be less than 100 characters'], isRequired: true, maxLength: 100 },
                    { type: 'text', text: 'Postcode', value: 'postcode', rules: [v => !!v || 'Postcode is required', v => !(v && v.length > 20) || 'Postcode must be less than 20 characters'], isRequired: true, maxLength: 20 },
                    { type: 'autocomplete', text: 'Country', value: 'countryId', rules: [v => !!v || 'Country is required'], isRequired: true, form: () => import('./CountryForm'), apiMethod: 'Countries', claim: 'Countries' },
                    { type: 'coordinates', text: 'Coordinates', value: 'coordinates', rules: [] },
                ],
                apiMethod: 'Addresses',
                formTitle: 'Address',
            }
        },
    };
</script>
